module.exports = __webpack_public_path__ + "img/group-3.614fabcb.jpg";